<div id="print-section">

  <table style="width: 100%; border-collapse: collapse; border-bottom: 1px solid black; background-color: #f8f9fa;">
    <tr>
      <td style="font-size: 18px; font-weight: bold; text-align: center; padding: 12px; width:33%;border-right:1px solid black;">हिंदुस्तान प्रकाशन संस्था</td>
      <td style="font-size: 20px; font-weight: bold; text-align: center; width:34%;border-right:1px solid black;">Business Report</td>
      <td style="font-size: 16px; text-align: right; padding: 12px; font-weight: bold; width:33%;">दिनांक : {{ today | date:'dd-MM-yyyy' }}</td>
    </tr>
    <tr style="border-top: 1px solid black;">
      <td style="font-size: 16px; font-weight: bold; text-align: center; padding: 12px;border-right:1px solid black;">विवेक पुस्तक प्रकाशन</td>
      <td style="font-size: 16px; font-weight: bold; text-align: center;border-right:1px solid black;">Very Briefly</td>
      <td style="font-size: 14px; text-align: right; padding: 12px; font-weight: bold;">From {{ startDate | date:'dd-MM-yyyy' }} To {{ endDate | date:'dd-MM-yyyy' }}</td>
    </tr>
  </table>

  <table border="1" cellspacing="0" cellpadding="5" style="border-collapse: collapse; width: 100%; font-family: Arial, sans-serif;">
    <thead>
      <tr style="background-color: #d3d3d3; text-align: center; font-weight: bold;">
        <th rowspan="2" style="width: 5%;">अ.क्र.</th>
        <th rowspan="2" style="width: 15%;">कार्यालयीन प्रतिनिधी</th>
        <th colspan="3" style="width: 25%;border-right:2px solid black;">चालू वर्षाचा आज अखेर पूर्ण व्यवसाय</th>
        <th colspan="3" style="width: 25%;border-right:2px solid black;">जमा रक्कम 2025-2026</th>
        <th colspan="3" style="width: 25%;">येणे बाकी</th>
      </tr>
      <tr style="background-color: #f0f0f0; text-align: center; font-weight: normal;">
        <th style="width: 5%;">दिलेले उद्दिष्ट</th>
        <th style="width: 5%;">झालेला व्यवसाय</th>
        <th style="width: 5%;border-right:3px solid black;">टक्के</th>
        <th style="width: 8%;">पुस्तक जमा</th>
        <th style="width: 8%;">देणगी/अन्य</th>
        <th style="width: 9%;border-right:3px solid black;">एकूण जमा</th>
        <th>{{ getPreviousYearRangeLabel(2024, endDate) }}</th>
           <th style="width: 10%;">
    {{ getFinancialYear(startDate, endDate) }}
  </th>
        <th style="width: 10%;">एकूण येणे बाकी</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let group of report; let gi = index">
        <tr *ngFor="let row of group.rows; let i = index">
          <td style="text-align: center;">{{ getSerialNumber(gi, i) }}</td>
          <td>{{ row.office_rep_name }}</td>

          <!-- दिलेले उद्दिष्ट -->
          <td>
            <input
              type="number"
              [(ngModel)]="row.target_amt"
              (ngModelChange)="onTargetChange(row)"
              style="width: 100px; text-align: right; margin-left: 5px;"
            >
          </td>

          <td style="text-align: right;">{{ row.invoice_total | number:'1.0-0' }}</td>
          <td style="text-align: right; border-right:2px solid black;">
            {{ getPercentage(row.invoice_total) | number:'1.0-2' }} %
          </td>

          <!-- पुस्तक जमा -->
          <td style="text-align: right;">{{ row.total_amt1  }}</td>

          <!-- देणगी/अन्य -->
          <td>
            <input
              type="number"
              [(ngModel)]="row.other_amt"
              (ngModelChange)="onAmountChange(row)"
              style="width: 100px; text-align: right; margin-left: 5px;"
            >
          </td>

          <!-- एकूण जमा -->
          <td style="text-align: right; border-right:2px solid black;">
            {{ row.total_received_amt }}
          </td>

          <!-- एकूण 13 ते 25 -->
          <td style="text-align: right;">{{ row.prev_unpaid_amt }}</td>

          <!-- 25-26 -->
          <td style="text-align: right;">{{ row.total_unpaid_amt  }}</td>

          <!-- एकूण येणे बाकी -->
          <td style="text-align: right; font-weight: bold;">
            {{ (row.prev_unpaid_amt + row.total_unpaid_amt)  }}
          </td>
        </tr>
      </ng-container>

      <tr *ngIf="report.length === 0">
        <td colspan="11" style="text-align: center;">डेटा उपलब्ध नाही</td>
      </tr>

      <!-- Grand Total Row -->
      <tr style="background-color: #00d2d2; font-weight: bold;">
        <td colspan="2" style="text-align: center;">एकूण</td>
        <td style="text-align: right;">{{ grandTotals.target_amt  }}</td>
        <td style="text-align: right;">{{ grandTotals.invoice_total  }}</td>
        <td style="text-align: right;"></td>
        <td style="text-align: right;">{{ grandTotals.total_amt1  }}</td>
        <td style="text-align: right;">{{ grandTotals.other_amt  }}</td>
        <td style="text-align: right;">{{ grandTotals.total_received_amt  }}</td>
        <td style="text-align: right;">{{ grandTotals.prev_unpaid_amt  }}</td>
        <td style="text-align: right;">{{ grandTotals.total_unpaid_amt  }}</td>
        <td style="text-align: right; font-weight: bold;">
          {{ grandTotals.total_yene_baki  }}
        </td>
      </tr>
    </tbody>
  </table>

</div>

<div class="btn-section noPrint" style="margin-top: 15px; text-align:center;">
  <button mat-button mat-dialog-close>❌ Close</button>
  <button mat-raised-button color="primary" (click)="exportExcel('OfficeWise_Report')" style="margin-right: 10px;">📊 Export</button>
  <button mat-raised-button color="accent" (click)="printReportA3()">🖨️ Print</button>
</div>